import { formatPrice } from '@ab-core/functions';
import Text from '@ab-core/text';
import type { MoneyObject } from '@ab-core/types/src';
import type { FC } from 'react';
import React from 'react';

type DiscountSumType = {
    discountSum: MoneyObject;
};

export const DiscountSum: FC<DiscountSumType> = (props) => {
    const { discountSum } = props;

    return (
        <div className="flex-justify-content-space-between">
            <Text>Nachlass:</Text>
            <Text color="info"> -{formatPrice(discountSum)}</Text>
        </div>
    );
};
